import CodeManage from './Index.vue'

CodeManage.install = function(Vue) {
  Vue.component(CodeManage.name, CodeManage)
}

import SimpleCode from './SimpleCode.vue'

SimpleCode.install = function(Vue) {
  Vue.component(SimpleCode.name, SimpleCode)
}

import SimpleCodeEdit from './Edit.vue'

SimpleCodeEdit.install = function(Vue) {
  Vue.component(SimpleCodeEdit.name, SimpleCodeEdit)
}

export { CodeManage, SimpleCode, SimpleCodeEdit }
